module.exports = __webpack_public_path__ + "static/media/slide3.e6dbcbbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/StartupIncludes/assets/slide3.png
// module id = 541
// module chunks = 0